<div class="p-3 h-[calc(100%-var(--spacing)*15)]">
  <app-breadcrumb [items]="[{ label: 'Release Management' }, { label: 'Environment Delta' }]"/>
  <div class="h-[calc(100%-var(--spacing)*9)] rounded-sm border border-stroke bg-white shadow-default dark:border-strokedark dark:bg-boxdark">
    <div class="h-full w-full overflow-y-scroll">

      <!-- Toolbar -->
      <div class="sticky top-0 left-0 z-10 flex flex-wrap items-center gap-3 border-b border-stroke bg-white px-5 py-4 dark:border-strokedark dark:bg-boxdark sm:px-7.5">

        <!-- View mode tabs -->
        <div class="flex items-center rounded-lg border border-gray-200 bg-gray-50 dark:border-gray-700 dark:bg-gray-800">
          <button type="button" (click)="setViewMode('full')" [disabled]="loading()"
            class="rounded-md px-3.5 py-2 text-sm font-medium transition-colors disabled:cursor-not-allowed"
            [class.bg-gray-300]="viewMode === 'full'" [class.shadow-sm]="viewMode === 'full'" [class.text-gray-800]="viewMode === 'full'"
            [class.dark:bg-gray-800]="viewMode === 'full'" [class.dark:text-white]="viewMode === 'full'"
            [class.text-gray-500]="viewMode !== 'full'" [class.dark:text-gray-400]="viewMode !== 'full'">
            All Organizations
          </button>
          <button type="button" (click)="setViewMode('organization')" [disabled]="loading()"
            class="rounded-md px-3.5 py-2 text-sm font-medium transition-colors disabled:cursor-not-allowed"
            [class.bg-gray-300]="viewMode === 'organization'" [class.shadow-sm]="viewMode === 'organization'" [class.text-gray-800]="viewMode === 'organization'"
            [class.dark:bg-gray-800]="viewMode === 'organization'" [class.dark:text-white]="viewMode === 'organization'"
            [class.text-gray-500]="viewMode !== 'organization'" [class.dark:text-gray-400]="viewMode !== 'organization'">
            Single Organization
          </button>
        </div>

        <div>
          <label class="mb-1 block text-xs text-gray-500 dark:text-gray-400">Environments</label>
          <select [ngModel]="selectedDirectionKey" (ngModelChange)="onDirectionChange($event)"
            class="h-9 rounded-lg border border-gray-300 bg-white px-3 text-sm font-medium uppercase text-gray-800 shadow-sm focus:outline-none dark:border-gray-700 dark:bg-gray-900 dark:text-white">
            @for (dir of directionOptions; track directionKey(dir.source, dir.target)) {
              <option [value]="directionKey(dir.source, dir.target)">{{ dir.source | uppercase }} &rarr; {{ dir.target | uppercase }}</option>
            }
          </select>
        </div>

        @if (viewMode === 'organization') {
          <div>
            <label class="mb-1 block text-xs text-gray-500 dark:text-gray-400">Organization</label>
            <select [(ngModel)]="organizationId"
              class="h-9 rounded-lg border border-gray-300 bg-white px-3 text-sm text-gray-800 shadow-sm focus:outline-none dark:border-gray-700 dark:bg-gray-900 dark:text-white">
              <option value="" disabled>Select organization</option>
              @for (org of organizationStore.organizations(); track org.id) {
                <option [value]="org.id">{{ org.name }}</option>
              }
            </select>
          </div>
        }

        @if (viewMode === 'full') {
          <label class="mt-5 flex items-center gap-2 text-sm text-gray-600 dark:text-gray-400">
            <input type="checkbox" [(ngModel)]="onlyWithDelta" class="h-4 w-4 rounded border-gray-300 dark:border-gray-700"/>
            Only with delta
          </label>
        }

        <button type="button" (click)="run()" [disabled]="!canRun || loading()"
          class="mt-5 flex items-center gap-2 rounded-lg bg-blue-600 px-4 py-2 text-sm font-medium text-white hover:bg-blue-700 disabled:cursor-not-allowed disabled:opacity-50">
          @if (loading()) {
            <svg class="h-4 w-4 animate-spin" viewBox="0 0 24 24" fill="none"><circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"/><path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8v8H4z"/></svg>
            Comparing...
          } @else {
            Compare
          }
        </button>

        @if (!canCompare) {
          <p class="mt-5 text-xs text-red-500">Source and target must be different.</p>
        } @else if (viewMode === 'organization' && !organizationId) {
          <p class="mt-5 text-xs text-red-500">Select an organization.</p>
        }
      </div>

      <!-- Error -->
      @if (error()) {
        <div class="px-5 pt-4">
          <p class="rounded-lg border border-red-200 bg-red-100 p-3 text-sm text-red-600">{{ error() }}</p>
        </div>
      }

      <!-- Loading -->
      @if (loading()) {
        <div class="grid gap-6 p-6">
          <div class="flex bg-gray-200 h-12 gap-3 p-3 rounded-lg shimmer">
            <span class="rounded bg-blue-100 px-2.5 min-w-10 py-0.5 text-sm font-bold uppercase text-blue-700 blur-xs select-none">DEV</span>
            <svg xmlns="http://www.w3.org/2000/svg" class="h-4 w-4 text-gray-400" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M5 12h14"/><path d="m12 5 7 7-7 7"/></svg>
            <span class="rounded bg-purple-100 px-2.5 min-w-10 py-0.5 text-sm font-bold uppercase text-purple-700 blur-xs select-none">EU</span>
          </div>
          <div class="flex flex-col w-full gap-2 rounded-lg border border-gray-200 dark:border-gray-700">
            <div class="flex w-full justify-between items-center bg-gray-50 h-10 p-4 text-xs uppercase">
              <div class="blur-xs select-none">ORGANIZATION</div>
              <div class="blur-xs select-none">STATUS</div>
              <div class="blur-xs select-none">ORGANIZATION</div>
              <div class="blur-xs select-none">SURVEY</div>
              <div class="blur-xs select-none">ALERTS</div>
            </div>
            @for (i of [0,1,2,3,4]; track i) {
            <div class="flex bg-gray-200 w-full p-3 items-center shimmer">
              <div class="flex-1 px-4">
                <p class="blur-xs select-none font-medium text-gray-800 dark:text-gray-200">organization Name</p>
                <p class="blur-xs select-none font-mono text-xs text-gray-400">h6dae205-ae5a-4f8c-b2ec-144b4f3fd2c6</p>
              </div>
              <div class="inline-block rounded-lg border border-gray-300 mx-3 px-3 py-1.5 text-xs font-medium text-gray-600 dark:border-gray-700 dark:text-gray-300 blur-xs select-none">Breakdown</div>
              <div class="inline-block rounded-lg border border-gray-300 mx-3 px-3 py-1.5 text-xs font-medium text-gray-600 dark:border-gray-700 dark:text-gray-300 blur-xs select-none">Full Diff</div>
            </div>
            }
          </div>
        </div>
      }

      <!-- ══════════════ Full delta (all organizations) ══════════════ -->
      @if (viewMode === 'full') {

        <!-- Empty state -->
        @if (!loading() && !fullDeltaResult && !error()) {
          <div class="flex flex-col items-center justify-center py-24 text-gray-400">
            <svg xmlns="http://www.w3.org/2000/svg" class="mb-3 h-10 w-10 opacity-40" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round">
              <circle cx="11" cy="11" r="8"/><path d="m21 21-4.35-4.35"/>
            </svg>
            <p class="text-sm">Select source and target environments, then click Compare.</p>
          </div>
        }

        @if (fullDeltaResult && !loading()) {
          <div class="space-y-6 p-5">

            <!-- Summary bar -->
            <div class="flex flex-wrap items-center gap-3 rounded-lg border border-gray-200 bg-gray-50 px-4 py-3 dark:border-gray-700 dark:bg-gray-800">
              <span class="rounded bg-blue-100 px-2.5 py-0.5 text-sm font-bold uppercase text-blue-700">{{ fullDeltaResult.source }}</span>
              <svg xmlns="http://www.w3.org/2000/svg" class="h-4 w-4 text-gray-400" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M5 12h14"/><path d="m12 5 7 7-7 7"/></svg>
              <span class="rounded bg-purple-100 px-2.5 py-0.5 text-sm font-bold uppercase text-purple-700">{{ fullDeltaResult.target }}</span>
              <div class="ml-auto flex flex-wrap gap-4 text-sm">
                <span class="text-gray-500 dark:text-gray-400">{{ fullDeltaResult.summary.organizationsAnalysed }} analysed</span>
                @if (fullDeltaResult.summary.organizationsWithDelta > 0) {
                  <span class="font-medium text-amber-600">{{ fullDeltaResult.summary.organizationsWithDelta }} with delta</span>
                } @else {
                  <span class="text-green-600">All identical</span>
                }
                @if (fullDeltaResult.summary.organizationsSkippedObsolete > 0) {
                  <span class="text-gray-500 dark:text-gray-400">{{ fullDeltaResult.summary.organizationsSkippedObsolete }} skipped (obsolete)</span>
                }
                @if (fullDeltaResult.summary.organizationsFailed > 0) {
                  <span class="font-medium text-red-600">{{ fullDeltaResult.summary.organizationsFailed }} failed</span>
                }
              </div>
            </div>

            <!-- Organizations table -->
            <div class="overflow-x-auto rounded-lg border border-gray-200 dark:border-gray-700">
              <table class="w-full text-left text-sm text-gray-700 dark:text-gray-300">
                <thead class="bg-gray-50 text-xs uppercase text-gray-500 dark:bg-gray-800 dark:text-gray-400">
                  <tr>
                    <th class="px-4 py-2.5">Organization</th>
                    <th class="px-4 py-2.5">Status</th>
                    @for (area of fullDeltaResult.areas; track area) {
                      <th class="px-4 py-2.5">{{ areaLabels[area] }}</th>
                    }
                    <th class="px-4 py-2.5"></th>
                  </tr>
                </thead>
                <tbody>
                  @for (org of filteredOrganizations; track org.organizationId) {
                    <tr class="border-t border-gray-100 dark:border-gray-800"
                      [class.bg-amber-50]="org.hasDelta && !org.error" [class.dark:bg-amber-500/5]="org.hasDelta && !org.error"
                      [class.bg-red-50]="!!org.error" [class.dark:bg-red-500/5]="!!org.error">
                      <td class="px-4 py-2.5">
                        <p class="font-medium text-gray-800 dark:text-gray-200">{{ org.organizationName }}</p>
                        <p class="font-mono text-xs text-gray-400">{{ org.organizationId }}</p>
                      </td>
                      <td class="px-4 py-2.5">
                        @if (org.error) {
                          <span class="inline-flex items-center gap-1 rounded-full bg-red-100 px-2 py-0.5 text-xs font-medium text-red-700 dark:bg-red-500/10 dark:text-red-400">
                            Failed
                            <app-info-tooltip>{{ org.error }}</app-info-tooltip>
                          </span>
                        } @else {
                          <span class="rounded-full px-2 py-0.5 text-xs font-medium"
                            [class.bg-amber-100]="org.hasDelta" [class.text-amber-700]="org.hasDelta"
                            [class.bg-green-100]="!org.hasDelta" [class.text-green-700]="!org.hasDelta">
                            {{ org.status }}
                          </span>
                        }
                      </td>
                      @for (area of fullDeltaResult.areas; track area) {
                        @let detail = getAreaDetail(org, area);
                        <td class="px-4 py-2.5">
                          @if (detail) {
                            <span class="inline-flex items-center gap-2"
                              [class.text-amber-600]="detail.hasDelta" [class.text-gray-400]="!detail.hasDelta">
                              {{ detail.itemsWithDelta }}/{{ detail.itemsCompared }}
                              @if (detail.hasDelta) {
                                <span class="text-xs font-medium text-green-600">+{{ detail.added }}</span>
                                <span class="text-xs font-medium text-red-600">-{{ detail.removed }}</span>
                                <span class="text-xs font-medium text-amber-600">~{{ detail.modified }}</span>
                              }
                            </span>
                          } @else {
                            <span class="text-gray-300">—</span>
                          }
                        </td>
                      }
                      <td class="px-4 py-2.5 text-right">
                        <div class="flex justify-end gap-2">
                          @if (org.hasDelta && !org.error) {
                            <button type="button" (click)="toggleChange('org-' + org.organizationId)"
                              class="flex items-center gap-1 rounded-lg border border-gray-300 px-3 py-1.5 text-xs font-medium text-gray-600 hover:bg-gray-100 dark:border-gray-700 dark:text-gray-300 dark:hover:bg-gray-800">
                              {{ isExpanded('org-' + org.organizationId) ? 'Hide' : 'Breakdown' }}
                              <svg class="h-3.5 w-3.5 shrink-0 transition-transform duration-200" [class.rotate-180]="isExpanded('org-' + org.organizationId)"
                                viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                                <path d="m6 9 6 6 6-6"/>
                              </svg>
                            </button>
                          }
                          <button type="button" (click)="viewOrganizationDetail(org.organizationId)" [disabled]="!!org.error"
                            class="rounded-lg border border-gray-300 px-3 py-1.5 text-xs font-medium text-gray-600 hover:bg-gray-100 disabled:cursor-not-allowed disabled:opacity-40 dark:border-gray-700 dark:text-gray-300 dark:hover:bg-gray-800">
                            Full Diff
                          </button>
                        </div>
                      </td>
                    </tr>
                    @if (isExpanded('org-' + org.organizationId)) {
                      <tr class="border-t border-gray-100 dark:border-gray-800">
                        <td [attr.colspan]="fullDeltaResult.areas.length + 3" class="bg-gray-50 px-4 py-3 dark:bg-gray-900">
                          <table class="w-full text-xs text-gray-600 dark:text-gray-300">
                            <thead>
                              <tr class="text-left text-gray-400 dark:text-gray-500">
                                <th class="pb-1.5 pr-4 font-medium">Area</th>
                                <th class="pb-1.5 pr-4 font-medium">Compared</th>
                                <th class="pb-1.5 pr-4 font-medium">With Delta</th>
                                <th class="pb-1.5 pr-4 font-medium">Only in Source</th>
                                <th class="pb-1.5 pr-4 font-medium">Only in Target</th>
                                <th class="pb-1.5 pr-4 font-medium">Sections</th>
                                <th class="pb-1.5 pr-4 font-medium">Changes</th>
                                <th class="pb-1.5 pr-4 font-medium text-green-600">Added</th>
                                <th class="pb-1.5 pr-4 font-medium text-red-600">Removed</th>
                                <th class="pb-1.5 font-medium text-amber-600">Modified</th>
                              </tr>
                            </thead>
                            <tbody class="divide-y divide-gray-200 dark:divide-gray-800">
                              @for (area of fullDeltaResult.areas; track area) {
                                @let detail = getAreaDetail(org, area);
                                @if (detail) {
                                  <tr>
                                    <td class="py-1.5 pr-4 font-medium text-gray-700 dark:text-gray-300">{{ areaLabels[area] }}</td>
                                    <td class="py-1.5 pr-4">{{ detail.itemsCompared }}</td>
                                    <td class="py-1.5 pr-4" [class.font-semibold]="detail.hasDelta" [class.text-amber-600]="detail.hasDelta">{{ detail.itemsWithDelta }}</td>
                                    <td class="py-1.5 pr-4">{{ detail.itemsOnlyInSource }}</td>
                                    <td class="py-1.5 pr-4">{{ detail.itemsOnlyInTarget }}</td>
                                    <td class="py-1.5 pr-4">{{ detail.changedSections }}</td>
                                    <td class="py-1.5 pr-4">{{ detail.changes }}</td>
                                    <td class="py-1.5 pr-4 text-green-600">{{ detail.added }}</td>
                                    <td class="py-1.5 pr-4 text-red-600">{{ detail.removed }}</td>
                                    <td class="py-1.5 text-amber-600">{{ detail.modified }}</td>
                                  </tr>
                                }
                              }
                            </tbody>
                          </table>
                        </td>
                      </tr>
                    }
                  } @empty {
                    <tr><td [attr.colspan]="fullDeltaResult.areas.length + 3" class="px-4 py-8 text-center text-gray-400">No organizations to show.</td></tr>
                  }
                </tbody>
              </table>
            </div>

          </div>
        }
      }

      <!-- ══════════════ Single organization (detailed) ══════════════ -->
      @if (viewMode === 'organization') {

        <!-- Empty state -->
        @if (!loading() && !deltaResult && !error()) {
          <div class="flex flex-col items-center justify-center py-24 text-gray-400">
            <svg xmlns="http://www.w3.org/2000/svg" class="mb-3 h-10 w-10 opacity-40" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round">
              <circle cx="11" cy="11" r="8"/><path d="m21 21-4.35-4.35"/>
            </svg>
            <p class="text-sm">Select an organization, then click Compare.</p>
          </div>
        }

      <!-- Results -->
      @if (deltaResult && !loading()) {
        <div class="space-y-6 p-5">

          <!-- Summary bar -->
          <div class="flex flex-wrap items-center gap-3 rounded-lg border border-gray-200 bg-gray-50 px-4 py-3 dark:border-gray-700 dark:bg-gray-800">
            <span class="rounded bg-blue-100 px-2.5 py-0.5 text-sm font-bold uppercase text-blue-700">{{ deltaResult.source }}</span>
            <svg xmlns="http://www.w3.org/2000/svg" class="h-4 w-4 text-gray-400" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M5 12h14"/><path d="m12 5 7 7-7 7"/></svg>
            <span class="rounded bg-purple-100 px-2.5 py-0.5 text-sm font-bold uppercase text-purple-700">{{ deltaResult.target }}</span>
            <div class="ml-auto flex flex-wrap gap-4 text-sm">
              @if (deltaResult.organization.hasDelta) {
                <span class="font-medium text-amber-600">{{ totalOrgChanges() }} org change{{ totalOrgChanges() !== 1 ? 's' : '' }}</span>
              } @else {
                <span class="text-green-600">Org identical</span>
              }
              @if (surveysOnlyInSource.length > 0) {
                <span class="font-medium text-orange-600">{{ surveysOnlyInSource.length }} only in source</span>
              }
              @if (surveysOnlyInTarget.length > 0) {
                <span class="font-medium text-indigo-600">{{ surveysOnlyInTarget.length }} only in target</span>
              }
              @if (surveysModified.length > 0) {
                <span class="font-medium text-amber-600">{{ surveysModified.length }} survey modified</span>
              }
              @if (surveysIdentical.length > 0) {
                <span class="text-green-600">{{ surveysIdentical.length }} surveys identical</span>
              }
              @if (alertsOnlyInSource.length > 0) {
                <span class="font-medium text-orange-600">{{ alertsOnlyInSource.length }} alert{{ alertsOnlyInSource.length === 1 ? '' : 's' }} only in source</span>
              }
              @if (alertsOnlyInTarget.length > 0) {
                <span class="font-medium text-indigo-600">{{ alertsOnlyInTarget.length }} alert{{ alertsOnlyInTarget.length === 1 ? '' : 's' }} only in target</span>
              }
              @if (alertsModified.length > 0) {
                <span class="font-medium text-amber-600">{{ alertsModified.length }} alert{{ alertsModified.length === 1 ? '' : 's' }} modified</span>
              }
              @if (alertsIdentical.length > 0) {
                <span class="text-green-600">{{ alertsIdentical.length }} alert{{ alertsIdentical.length === 1 ? '' : 's' }} identical</span>
              }
            </div>
          </div>

          <!-- ── Organization Changes ── -->
          @if (deltaResult.organization.hasDelta) {
            <div>
              <h3 class="mb-3 text-sm font-semibold text-gray-700 dark:text-gray-200">Organization Changes</h3>
              <div class="space-y-3">
                @for (section of deltaResult.organization.sections; track section.section) {
                  <div class="overflow-hidden rounded-lg border border-gray-200 dark:border-gray-700">

                    <!-- Section header -->
                    <div class="flex items-center gap-2 border-b border-gray-200 bg-gray-50 px-4 py-2.5 dark:border-gray-700 dark:bg-gray-800">
                      <span class="text-sm font-semibold text-gray-700 dark:text-gray-200">{{ formatSectionName(section.section) }}</span>
                      <span class="rounded-full bg-amber-100 px-2 py-0.5 text-xs font-medium text-amber-700 dark:bg-amber-900 dark:text-amber-300">
                        {{ section.changes.length }} change{{ section.changes.length !== 1 ? 's' : '' }}
                      </span>
                    </div>

                    <!-- Changes -->
                    <div class="divide-y divide-gray-100 dark:divide-gray-700">
                      @for (change of section.changes; track change.key) {
                        @let cid = section.section + '-' + change.key;
                        <div>
                          <!-- Change row toggle -->
                          <button type="button" (click)="toggleChange(cid)"
                            class="flex w-full items-center gap-2 px-4 py-2.5 text-left hover:bg-gray-50 dark:hover:bg-gray-800">
                            <span class="shrink-0 rounded px-1.5 py-0.5 text-xs font-bold uppercase"
                              [class.bg-amber-100]="change.op === 'modify'"
                              [class.text-amber-700]="change.op === 'modify'"
                              [class.bg-green-100]="change.op === 'add'"
                              [class.text-green-700]="change.op === 'add'"
                              [class.bg-red-100]="change.op === 'remove'"
                              [class.text-red-700]="change.op === 'remove'">
                              {{ change.op }}
                            </span>
                            <span class="font-mono text-sm font-medium text-gray-800 dark:text-gray-200">{{ change.key }}</span>
                            @if (change.path) {
                              <span class="text-xs text-gray-400">&bull; {{ change.path }}</span>
                            }
                            <svg class="ml-auto h-4 w-4 shrink-0 text-gray-400 transition-transform duration-200"
                              [class.rotate-180]="isExpanded(cid)"
                              viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                              <path d="m6 9 6 6 6-6"/>
                            </svg>
                          </button>

                          <!-- Diff panel -->
                          @if (isExpanded(cid)) {
                            <div class="border-t border-gray-100 bg-gray-50 px-4 py-3 dark:border-gray-700 dark:bg-gray-900">
                              @if (isPlainObject(change.from) && isPlainObject(change.to)) {
                                @let diff = computePropertyDiff(change.from, change.to);
                                <div class="overflow-x-auto">
                                  <table class="w-full text-xs">
                                    <thead>
                                      <tr class="text-left text-gray-500">
                                        <th class="pb-2 pr-4 font-medium w-48">Property</th>
                                        <th class="pb-2 pr-4 font-medium">
                                          Source
                                          <span class="ml-1 rounded bg-blue-100 px-1.5 py-0.5 font-bold uppercase text-blue-700">{{ deltaResult.source }}</span>
                                        </th>
                                        <th class="pb-2 font-medium">
                                          Target
                                          <span class="ml-1 rounded bg-purple-100 px-1.5 py-0.5 font-bold uppercase text-purple-700">{{ deltaResult.target }}</span>
                                        </th>
                                      </tr>
                                    </thead>
                                    <tbody class="divide-y divide-gray-100 dark:divide-gray-700">
                                      @for (row of diff; track row.key) {
                                        @if (row.status !== 'same') {
                                          <tr
                                            [class.bg-red-50]="row.status === 'removed'"
                                            [class.bg-green-50]="row.status === 'added'"
                                            [class.bg-amber-50]="row.status === 'modified'">
                                            <td class="py-2 pr-4 align-top font-mono text-gray-600">{{ row.key }}</td>
                                            <td class="py-2 pr-4 align-top break-all"
                                              [class.text-red-700]="row.status === 'removed' || row.status === 'modified'"
                                              [class.text-gray-300]="row.status === 'added'">
                                              {{ row.fromVal ?? '—' }}
                                            </td>
                                            <td class="py-2 align-top break-all"
                                              [class.text-green-700]="row.status === 'added' || row.status === 'modified'"
                                              [class.text-gray-300]="row.status === 'removed'">
                                              {{ row.toVal ?? '—' }}
                                            </td>
                                          </tr>
                                        }
                                      }
                                    </tbody>
                                  </table>
                                </div>
                                @if (countSame(diff) > 0) {
                                  <p class="mt-2 text-xs text-gray-400">{{ countSame(diff) }} unchanged {{ countSame(diff) === 1 ? 'property' : 'properties' }} not shown.</p>
                                }
                              } @else {
                                <!-- Side-by-side JSON for arrays / non-objects, with word-level diff highlighting -->
                                @let textDiff = computeTextDiff(change.from, change.to);
                                <div class="grid grid-cols-2 gap-3">
                                  <div>
                                    <p class="mb-1.5 text-xs font-medium text-gray-500">
                                      Source <span class="rounded bg-blue-100 px-1.5 py-0.5 font-bold uppercase text-blue-700">{{ deltaResult.source }}</span>
                                    </p>
                                    <pre class="max-h-56 overflow-auto rounded border border-red-200 bg-red-50 p-2.5 text-xs text-red-800 whitespace-pre-wrap dark:border-red-800 dark:bg-red-950 dark:text-red-300">@for (seg of textDiff.fromSegments; track $index) {<span [class.bg-red-200]="seg.changed" [class.line-through]="seg.changed" [class.dark:bg-red-800]="seg.changed">{{ seg.text }}</span>}</pre>
                                  </div>
                                  <div>
                                    <p class="mb-1.5 text-xs font-medium text-gray-500">
                                      Target <span class="rounded bg-purple-100 px-1.5 py-0.5 font-bold uppercase text-purple-700">{{ deltaResult.target }}</span>
                                    </p>
                                    <pre class="max-h-56 overflow-auto rounded border border-green-200 bg-green-50 p-2.5 text-xs text-green-800 whitespace-pre-wrap dark:border-green-800 dark:bg-green-950 dark:text-green-300">@for (seg of textDiff.toSegments; track $index) {<span [class.bg-green-200]="seg.changed" [class.font-semibold]="seg.changed" [class.dark:bg-green-800]="seg.changed">{{ seg.text }}</span>}</pre>
                                  </div>
                                </div>
                              }
                            </div>
                          }
                        </div>
                      }
                    </div>
                  </div>
                }
              </div>
            </div>
          } @else {
            <div class="flex items-center gap-2 rounded-lg border border-green-200 bg-green-50 px-4 py-3 text-sm text-green-700 dark:border-green-800 dark:bg-green-950 dark:text-green-300">
              <svg xmlns="http://www.w3.org/2000/svg" class="h-4 w-4 shrink-0" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"/></svg>
              Organization configuration is identical between environments.
            </div>
          }

          <!-- ── Surveys ── -->
          <div>
            <h3 class="mb-3 text-sm font-semibold text-gray-700 dark:text-gray-200">
              Surveys
              <span class="ml-1.5 text-xs font-normal text-gray-400">({{ deltaResult.surveys.length }} total)</span>
            </h3>
            <div class="grid grid-cols-1 gap-4 md:grid-cols-2">

              <!-- Only in Source -->
              @if (surveysOnlyInSource.length > 0) {
                <div class="rounded-lg border border-orange-200 bg-orange-50 p-4 dark:border-orange-800 dark:bg-orange-950">
                  <div class="mb-3 flex items-center gap-2">
                    <span class="h-2 w-2 shrink-0 rounded-full bg-orange-400"></span>
                    <span class="text-sm font-semibold text-orange-700 dark:text-orange-300">Only in Source</span>
                    <span class="rounded-full bg-orange-200 px-2 py-0.5 text-xs font-bold text-orange-800 dark:bg-orange-800 dark:text-orange-200">{{ surveysOnlyInSource.length }}</span>
                  </div>
                  <div class="flex flex-wrap gap-1.5">
                  @for (s of surveysOnlyInSource; track s.surveyId) {
                    <span class="rounded-full border border-orange-300 bg-white px-2.5 py-1 text-xs font-medium text-orange-800 dark:border-orange-700 dark:bg-orange-900 dark:text-orange-300">{{ s.surveyId }}</span>
                  }
                  </div>
                </div>
              }

              <!-- Only in Target -->
              @if (surveysOnlyInTarget.length > 0) {
                <div class="rounded-lg border border-indigo-200 bg-indigo-50 p-4 dark:border-indigo-800 dark:bg-indigo-950">
                  <div class="mb-3 flex items-center gap-2">
                    <span class="h-2 w-2 shrink-0 rounded-full bg-indigo-400"></span>
                    <span class="text-sm font-semibold text-indigo-700 dark:text-indigo-300">Only in Target</span>
                    <span class="rounded-full bg-indigo-200 px-2 py-0.5 text-xs font-bold text-indigo-800 dark:bg-indigo-800 dark:text-indigo-200">{{ surveysOnlyInTarget.length }}</span>
                  </div>
                  <div class="flex flex-wrap gap-1.5">
                  @for (s of surveysOnlyInTarget; track s.surveyId) {
                    <span class="rounded-full border border-indigo-300 bg-white px-2.5 py-1 text-xs font-medium text-indigo-800 dark:border-indigo-700 dark:bg-indigo-900 dark:text-indigo-300">{{ s.surveyId }}</span>
                  }
                  </div>
                </div>
              }

              <!-- Identical -->
              @if (surveysIdentical.length > 0) {
                <div class="rounded-lg border border-green-200 bg-green-50 p-4 dark:border-green-800 dark:bg-green-950">
                  <div class="mb-3 flex items-center gap-2">
                    <span class="h-2 w-2 shrink-0 rounded-full bg-green-400"></span>
                    <span class="text-sm font-semibold text-green-700 dark:text-green-300">Identical</span>
                    <span class="rounded-full bg-green-200 px-2 py-0.5 text-xs font-bold text-green-800 dark:bg-green-800 dark:text-green-200">{{ surveysIdentical.length }}</span>
                  </div>
                  <div class="flex flex-wrap gap-1.5">
                  @for (s of surveysIdentical; track s.surveyId) {
                    <span class="rounded-full border border-green-300 bg-white px-2.5 py-1 text-xs font-medium text-green-800 dark:border-green-700 dark:bg-green-900 dark:text-green-300">{{ s.surveyId }}</span>
                  }
                  </div>
                </div>
              }

            </div>
          </div>

          <!-- ── Modified Surveys (detailed) ── -->
          @if (surveysModified.length > 0) {
            <div>
              <h3 class="mb-3 text-sm font-semibold text-gray-700 dark:text-gray-200">
                Modified Surveys
                <span class="ml-1.5 text-xs font-normal text-gray-400">({{ surveysModified.length }})</span>
              </h3>
              <div class="space-y-3">
                @for (survey of surveysModified; track survey.surveyId) {
                  @let sid = 'survey-' + survey.surveyId;
                  <div class="overflow-hidden rounded-lg border border-amber-200 dark:border-amber-800">

                    <!-- Survey header toggle -->
                    <button type="button" (click)="toggleChange(sid)"
                      class="flex w-full items-center gap-2 bg-amber-50 px-4 py-2.5 text-left hover:bg-amber-100 dark:bg-amber-950 dark:hover:bg-amber-900">
                      <span class="font-mono text-sm font-medium text-amber-800 dark:text-amber-300">{{ survey.surveyId }}</span>
                      <span class="rounded-full bg-amber-200 px-2 py-0.5 text-xs font-bold text-amber-800 dark:bg-amber-800 dark:text-amber-200">
                        {{ totalChanges(survey.sections) }} change{{ totalChanges(survey.sections) !== 1 ? 's' : '' }}
                      </span>
                      <svg class="ml-auto h-4 w-4 shrink-0 text-amber-500 transition-transform duration-200"
                        [class.rotate-180]="isExpanded(sid)"
                        viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                        <path d="m6 9 6 6 6-6"/>
                      </svg>
                    </button>

                    @if (isExpanded(sid)) {
                      <div class="divide-y divide-gray-100 border-t border-amber-200 dark:divide-gray-700 dark:border-amber-800">
                        @for (section of survey.sections; track section.section) {
                          <div>
                            <!-- Section header -->
                            <div class="flex items-center gap-2 bg-gray-50 px-4 py-2 dark:bg-gray-800">
                              <span class="text-sm font-semibold text-gray-700 dark:text-gray-200">{{ formatSectionName(section.section) }}</span>
                              <span class="rounded-full bg-amber-100 px-2 py-0.5 text-xs font-medium text-amber-700 dark:bg-amber-900 dark:text-amber-300">
                                {{ section.changes.length }} change{{ section.changes.length !== 1 ? 's' : '' }}
                              </span>
                            </div>

                            <!-- Changes -->
                            <div class="divide-y divide-gray-100 dark:divide-gray-700">
                              @for (change of section.changes; track change.key) {
                                @let cid = sid + '-' + section.section + '-' + change.key;
                                <div>
                                  <!-- Change row toggle -->
                                  <button type="button" (click)="toggleChange(cid)"
                                    class="flex w-full items-center gap-2 px-4 py-2.5 text-left hover:bg-gray-50 dark:hover:bg-gray-800">
                                    <span class="shrink-0 rounded px-1.5 py-0.5 text-xs font-bold uppercase"
                                      [class.bg-amber-100]="change.op === 'modify'"
                                      [class.text-amber-700]="change.op === 'modify'"
                                      [class.bg-green-100]="change.op === 'add'"
                                      [class.text-green-700]="change.op === 'add'"
                                      [class.bg-red-100]="change.op === 'remove'"
                                      [class.text-red-700]="change.op === 'remove'">
                                      {{ change.op }}
                                    </span>
                                    <span class="font-mono text-sm font-medium text-gray-800 dark:text-gray-200">{{ change.key }}</span>
                                    @if (change.path) {
                                      <span class="text-xs text-gray-400">&bull; {{ change.path }}</span>
                                    }
                                    <svg class="ml-auto h-4 w-4 shrink-0 text-gray-400 transition-transform duration-200"
                                      [class.rotate-180]="isExpanded(cid)"
                                      viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                                      <path d="m6 9 6 6 6-6"/>
                                    </svg>
                                  </button>

                                  <!-- Diff panel -->
                                  @if (isExpanded(cid)) {
                                    <div class="border-t border-gray-100 bg-gray-50 px-4 py-3 dark:border-gray-700 dark:bg-gray-900">
                                      @if (isPlainObject(change.from) && isPlainObject(change.to)) {
                                        @let diff = computePropertyDiff(change.from, change.to);
                                        <div class="overflow-x-auto">
                                          <table class="w-full text-xs">
                                            <thead>
                                              <tr class="text-left text-gray-500">
                                                <th class="pb-2 pr-4 font-medium w-48">Property</th>
                                                <th class="pb-2 pr-4 font-medium">
                                                  Source
                                                  <span class="ml-1 rounded bg-blue-100 px-1.5 py-0.5 font-bold uppercase text-blue-700">{{ deltaResult.source }}</span>
                                                </th>
                                                <th class="pb-2 font-medium">
                                                  Target
                                                  <span class="ml-1 rounded bg-purple-100 px-1.5 py-0.5 font-bold uppercase text-purple-700">{{ deltaResult.target }}</span>
                                                </th>
                                              </tr>
                                            </thead>
                                            <tbody class="divide-y divide-gray-100 dark:divide-gray-700">
                                              @for (row of diff; track row.key) {
                                                @if (row.status !== 'same') {
                                                  <tr
                                                    [class.bg-red-50]="row.status === 'removed'"
                                                    [class.bg-green-50]="row.status === 'added'"
                                                    [class.bg-amber-50]="row.status === 'modified'">
                                                    <td class="py-2 pr-4 align-top font-mono text-gray-600">{{ row.key }}</td>
                                                    <td class="py-2 pr-4 align-top break-all"
                                                      [class.text-red-700]="row.status === 'removed' || row.status === 'modified'"
                                                      [class.text-gray-300]="row.status === 'added'">
                                                      {{ row.fromVal ?? '—' }}
                                                    </td>
                                                    <td class="py-2 align-top break-all"
                                                      [class.text-green-700]="row.status === 'added' || row.status === 'modified'"
                                                      [class.text-gray-300]="row.status === 'removed'">
                                                      {{ row.toVal ?? '—' }}
                                                    </td>
                                                  </tr>
                                                }
                                              }
                                            </tbody>
                                          </table>
                                        </div>
                                        @if (countSame(diff) > 0) {
                                          <p class="mt-2 text-xs text-gray-400">{{ countSame(diff) }} unchanged {{ countSame(diff) === 1 ? 'property' : 'properties' }} not shown.</p>
                                        }
                                      } @else {
                                        <!-- Side-by-side JSON for arrays / non-objects, with word-level diff highlighting -->
                                        @let textDiff = computeTextDiff(change.from, change.to);
                                        <div class="grid grid-cols-2 gap-3">
                                          <div>
                                            <p class="mb-1.5 text-xs font-medium text-gray-500">
                                              Source <span class="rounded bg-blue-100 px-1.5 py-0.5 font-bold uppercase text-blue-700">{{ deltaResult.source }}</span>
                                            </p>
                                            <pre class="max-h-56 overflow-auto rounded border border-red-200 bg-red-50 p-2.5 text-xs text-red-800 whitespace-pre-wrap dark:border-red-800 dark:bg-red-950 dark:text-red-300">@for (seg of textDiff.fromSegments; track $index) {<span [class.bg-red-200]="seg.changed" [class.line-through]="seg.changed" [class.dark:bg-red-800]="seg.changed">{{ seg.text }}</span>}</pre>
                                          </div>
                                          <div>
                                            <p class="mb-1.5 text-xs font-medium text-gray-500">
                                              Target <span class="rounded bg-purple-100 px-1.5 py-0.5 font-bold uppercase text-purple-700">{{ deltaResult.target }}</span>
                                            </p>
                                            <pre class="max-h-56 overflow-auto rounded border border-green-200 bg-green-50 p-2.5 text-xs text-green-800 whitespace-pre-wrap dark:border-green-800 dark:bg-green-950 dark:text-green-300">@for (seg of textDiff.toSegments; track $index) {<span [class.bg-green-200]="seg.changed" [class.font-semibold]="seg.changed" [class.dark:bg-green-800]="seg.changed">{{ seg.text }}</span>}</pre>
                                          </div>
                                        </div>
                                      }
                                    </div>
                                  }
                                </div>
                              }
                            </div>
                          </div>
                        }
                      </div>
                    }
                  </div>
                }
              </div>
            </div>
          }

          <!-- ── Alerts ── -->
          @if(deltaResult.alerts && deltaResult.alerts.length) {
          <div>
            <h3 class="mb-3 text-sm font-semibold text-gray-700 dark:text-gray-200">
              Alerts
              <span class="ml-1.5 text-xs font-normal text-gray-400">({{ deltaResult.alerts.length }} total)</span>
            </h3>
            <div class="grid grid-cols-1 gap-4 md:grid-cols-2">

              <!-- Only in Source -->
              @if (alertsOnlyInSource.length > 0) {
                <div class="rounded-lg border border-orange-200 bg-orange-50 p-4 dark:border-orange-800 dark:bg-orange-950">
                  <div class="mb-3 flex items-center gap-2">
                    <span class="h-2 w-2 shrink-0 rounded-full bg-orange-400"></span>
                    <span class="text-sm font-semibold text-orange-700 dark:text-orange-300">Only in Source</span>
                    <span class="rounded-full bg-orange-200 px-2 py-0.5 text-xs font-bold text-orange-800 dark:bg-orange-800 dark:text-orange-200">{{ alertsOnlyInSource.length }}</span>
                  </div>
                  <div class="flex flex-wrap gap-1.5">
                  @for (a of alertsOnlyInSource; track a.alertId) {
                    <span class="rounded-full border border-orange-300 bg-white px-2.5 py-1 text-xs font-medium text-orange-800 dark:border-orange-700 dark:bg-orange-900 dark:text-orange-300">{{ a.alertId }}</span>
                  }
                  </div>
                </div>
              }

              <!-- Only in Target -->
              @if (alertsOnlyInTarget.length > 0) {
                <div class="rounded-lg border border-indigo-200 bg-indigo-50 p-4 dark:border-indigo-800 dark:bg-indigo-950">
                  <div class="mb-3 flex items-center gap-2">
                    <span class="h-2 w-2 shrink-0 rounded-full bg-indigo-400"></span>
                    <span class="text-sm font-semibold text-indigo-700 dark:text-indigo-300">Only in Target</span>
                    <span class="rounded-full bg-indigo-200 px-2 py-0.5 text-xs font-bold text-indigo-800 dark:bg-indigo-800 dark:text-indigo-200">{{ alertsOnlyInTarget.length }}</span>
                  </div>
                  <div class="flex flex-wrap gap-1.5">
                  @for (a of alertsOnlyInTarget; track a.alertId) {
                    <span class="rounded-full border border-indigo-300 bg-white px-2.5 py-1 text-xs font-medium text-indigo-800 dark:border-indigo-700 dark:bg-indigo-900 dark:text-indigo-300">{{ a.alertId }}</span>
                  }
                  </div>
                </div>
              }

              <!-- Identical -->
              @if (alertsIdentical.length > 0) {
                <div class="rounded-lg border border-green-200 bg-green-50 p-4 dark:border-green-800 dark:bg-green-950">
                  <div class="mb-3 flex items-center gap-2">
                    <span class="h-2 w-2 shrink-0 rounded-full bg-green-400"></span>
                    <span class="text-sm font-semibold text-green-700 dark:text-green-300">Identical</span>
                    <span class="rounded-full bg-green-200 px-2 py-0.5 text-xs font-bold text-green-800 dark:bg-green-800 dark:text-green-200">{{ alertsIdentical.length }}</span>
                  </div>
                  <div class="flex flex-wrap gap-1.5">
                  @for (a of alertsIdentical; track a.alertId) {
                    <span class="rounded-full border border-green-300 bg-white px-2.5 py-1 text-xs font-medium text-green-800 dark:border-green-700 dark:bg-green-900 dark:text-green-300">{{ a.alertId }}</span>
                  }
                  </div>
                </div>
              }

            </div>
          </div>
          }

          <!-- ── Modified Alerts (detailed) ── -->
          @if (alertsModified.length > 0) {
            <div>
              <h3 class="mb-3 text-sm font-semibold text-gray-700 dark:text-gray-200">
                Modified Alerts
                <span class="ml-1.5 text-xs font-normal text-gray-400">({{ alertsModified.length }})</span>
              </h3>
              <div class="space-y-3">
                @for (alert of alertsModified; track alert.alertId) {
                  @let aid = 'alert-' + alert.alertId;
                  <div class="overflow-hidden rounded-lg border border-amber-200 dark:border-amber-800">

                    <!-- Alert header toggle -->
                    <button type="button" (click)="toggleChange(aid)"
                      class="flex w-full items-center gap-2 bg-amber-50 px-4 py-2.5 text-left hover:bg-amber-100 dark:bg-amber-950 dark:hover:bg-amber-900">
                      <span class="font-mono text-sm font-medium text-amber-800 dark:text-amber-300">{{ alert.alertId }}</span>
                      <span class="rounded-full bg-amber-200 px-2 py-0.5 text-xs font-bold text-amber-800 dark:bg-amber-800 dark:text-amber-200">
                        {{ totalChanges(alert.sections) }} change{{ totalChanges(alert.sections) !== 1 ? 's' : '' }}
                      </span>
                      <svg class="ml-auto h-4 w-4 shrink-0 text-amber-500 transition-transform duration-200"
                        [class.rotate-180]="isExpanded(aid)"
                        viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                        <path d="m6 9 6 6 6-6"/>
                      </svg>
                    </button>

                    @if (isExpanded(aid)) {
                      <div class="divide-y divide-gray-100 border-t border-amber-200 dark:divide-gray-700 dark:border-amber-800">
                        @for (section of alert.sections; track section.section) {
                          <div>
                            <!-- Section header -->
                            <div class="flex items-center gap-2 bg-gray-50 px-4 py-2 dark:bg-gray-800">
                              <span class="text-sm font-semibold text-gray-700 dark:text-gray-200">{{ formatSectionName(section.section) }}</span>
                              <span class="rounded-full bg-amber-100 px-2 py-0.5 text-xs font-medium text-amber-700 dark:bg-amber-900 dark:text-amber-300">
                                {{ section.changes.length }} change{{ section.changes.length !== 1 ? 's' : '' }}
                              </span>
                            </div>

                            <!-- Changes -->
                            <div class="divide-y divide-gray-100 dark:divide-gray-700">
                              @for (change of section.changes; track change.key) {
                                @let cid = aid + '-' + section.section + '-' + change.key;
                                <div>
                                  <!-- Change row toggle -->
                                  <button type="button" (click)="toggleChange(cid)"
                                    class="flex w-full items-center gap-2 px-4 py-2.5 text-left hover:bg-gray-50 dark:hover:bg-gray-800">
                                    <span class="shrink-0 rounded px-1.5 py-0.5 text-xs font-bold uppercase"
                                      [class.bg-amber-100]="change.op === 'modify'"
                                      [class.text-amber-700]="change.op === 'modify'"
                                      [class.bg-green-100]="change.op === 'add'"
                                      [class.text-green-700]="change.op === 'add'"
                                      [class.bg-red-100]="change.op === 'remove'"
                                      [class.text-red-700]="change.op === 'remove'">
                                      {{ change.op }}
                                    </span>
                                    <span class="font-mono text-sm font-medium text-gray-800 dark:text-gray-200">{{ change.key }}</span>
                                    @if (change.path) {
                                      <span class="text-xs text-gray-400">&bull; {{ change.path }}</span>
                                    }
                                    <svg class="ml-auto h-4 w-4 shrink-0 text-gray-400 transition-transform duration-200"
                                      [class.rotate-180]="isExpanded(cid)"
                                      viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                                      <path d="m6 9 6 6 6-6"/>
                                    </svg>
                                  </button>

                                  <!-- Diff panel -->
                                  @if (isExpanded(cid)) {
                                    <div class="border-t border-gray-100 bg-gray-50 px-4 py-3 dark:border-gray-700 dark:bg-gray-900">
                                      @if (isPlainObject(change.from) && isPlainObject(change.to)) {
                                        @let diff = computePropertyDiff(change.from, change.to);
                                        <div class="overflow-x-auto">
                                          <table class="w-full text-xs">
                                            <thead>
                                              <tr class="text-left text-gray-500">
                                                <th class="pb-2 pr-4 font-medium w-48">Property</th>
                                                <th class="pb-2 pr-4 font-medium">
                                                  Source
                                                  <span class="ml-1 rounded bg-blue-100 px-1.5 py-0.5 font-bold uppercase text-blue-700">{{ deltaResult.source }}</span>
                                                </th>
                                                <th class="pb-2 font-medium">
                                                  Target
                                                  <span class="ml-1 rounded bg-purple-100 px-1.5 py-0.5 font-bold uppercase text-purple-700">{{ deltaResult.target }}</span>
                                                </th>
                                              </tr>
                                            </thead>
                                            <tbody class="divide-y divide-gray-100 dark:divide-gray-700">
                                              @for (row of diff; track row.key) {
                                                @if (row.status !== 'same') {
                                                  <tr
                                                    [class.bg-red-50]="row.status === 'removed'"
                                                    [class.bg-green-50]="row.status === 'added'"
                                                    [class.bg-amber-50]="row.status === 'modified'">
                                                    <td class="py-2 pr-4 align-top font-mono text-gray-600">{{ row.key }}</td>
                                                    <td class="py-2 pr-4 align-top break-all"
                                                      [class.text-red-700]="row.status === 'removed' || row.status === 'modified'"
                                                      [class.text-gray-300]="row.status === 'added'">
                                                      {{ row.fromVal ?? '—' }}
                                                    </td>
                                                    <td class="py-2 align-top break-all"
                                                      [class.text-green-700]="row.status === 'added' || row.status === 'modified'"
                                                      [class.text-gray-300]="row.status === 'removed'">
                                                      {{ row.toVal ?? '—' }}
                                                    </td>
                                                  </tr>
                                                }
                                              }
                                            </tbody>
                                          </table>
                                        </div>
                                        @if (countSame(diff) > 0) {
                                          <p class="mt-2 text-xs text-gray-400">{{ countSame(diff) }} unchanged {{ countSame(diff) === 1 ? 'property' : 'properties' }} not shown.</p>
                                        }
                                      } @else {
                                        <!-- Side-by-side JSON for arrays / non-objects, with word-level diff highlighting -->
                                        @let textDiff = computeTextDiff(change.from, change.to);
                                        <div class="grid grid-cols-2 gap-3">
                                          <div>
                                            <p class="mb-1.5 text-xs font-medium text-gray-500">
                                              Source <span class="rounded bg-blue-100 px-1.5 py-0.5 font-bold uppercase text-blue-700">{{ deltaResult.source }}</span>
                                            </p>
                                            <pre class="max-h-56 overflow-auto rounded border border-red-200 bg-red-50 p-2.5 text-xs text-red-800 whitespace-pre-wrap dark:border-red-800 dark:bg-red-950 dark:text-red-300">@for (seg of textDiff.fromSegments; track $index) {<span [class.bg-red-200]="seg.changed" [class.line-through]="seg.changed" [class.dark:bg-red-800]="seg.changed">{{ seg.text }}</span>}</pre>
                                          </div>
                                          <div>
                                            <p class="mb-1.5 text-xs font-medium text-gray-500">
                                              Target <span class="rounded bg-purple-100 px-1.5 py-0.5 font-bold uppercase text-purple-700">{{ deltaResult.target }}</span>
                                            </p>
                                            <pre class="max-h-56 overflow-auto rounded border border-green-200 bg-green-50 p-2.5 text-xs text-green-800 whitespace-pre-wrap dark:border-green-800 dark:bg-green-950 dark:text-green-300">@for (seg of textDiff.toSegments; track $index) {<span [class.bg-green-200]="seg.changed" [class.font-semibold]="seg.changed" [class.dark:bg-green-800]="seg.changed">{{ seg.text }}</span>}</pre>
                                          </div>
                                        </div>
                                      }
                                    </div>
                                  }
                                </div>
                              }
                            </div>
                          </div>
                        }
                      </div>
                    }
                  </div>
                }
              </div>
            </div>
          }

        </div>
      }

      }

    </div>
  </div>
</div>
